import React from 'react';
import { Route } from 'react-router-dom';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { INavigationItemProps, SpaceWrapper, StickyNavigation } from 'ui-toolkit/index';
import { ClientCompaniesTab } from '../../pages/clients/ClientCompaniesTab';
import { ClientContactsPage } from '../../pages/clients/ClientContactsPage';
import { ClientOverviewPage } from '../../pages/clients/ClientOverviewPage';
import { ClientAssociatedLendersPage } from '../../pages/clients/ClientAssociatedLendersPage';
import { LenderCompanyContainer } from '../../pages/lenders/LenderCompanyContainer';
import { UserProfileContainer } from '../../components/userProfile/UserProfileContainer';
import { LenderCompaniesContainer } from '../../pages/lenders/LenderCompaniesContainer';
import { LenderCompanyCreatePage } from 'pages/lenders/LenderCompanyCreatePage';
import { LenderCompanyEditPage } from 'pages/lenders/LenderCompanyEditPage';
import { AssociatedLendersProvider } from '../../ui-toolkit/associatedLenders/AssociatedLendersProvider';

export const ClientCompaniesRouter = () => {
  const { path } = useRouteMatch();
  return (
    <AssociatedLendersProvider>
      <StickyNavigation activeMain={'Clients'} profile={<UserProfileContainer />} />
      <SpaceWrapper>
        <Switch>
          <Route path={`${path}/:clientId/associatedLenders`} exact component={ClientAssociatedLendersPage} />
          <Route path={`${path}/:clientId/clientOverview`} exact component={ClientOverviewPage} />
          <Route path={`${path}/:clientId`} exact component={ClientContactsPage} />
          <Route path={`${path}`} exact component={ClientCompaniesTab} />
          <Route path={'/*'} render={() => <Redirect to={`${path}`} />} />
        </Switch>
      </SpaceWrapper>
    </AssociatedLendersProvider>
  );
};

export const LenderCompaniesRouter = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/new`} exact component={LenderCompanyCreatePage} />
      <Route path={`${path}/:lenderId/edit`} exact component={LenderCompanyEditPage} />
      <Route path={`${path}/:lenderId`} exact component={LenderCompanyContainer} />
      <Route path={`${path}`} exact component={LenderCompaniesContainer} />
      <Route path={'/*'} render={() => <Redirect to={`${path}`} />} />
    </Switch>
  );
};

export const clientNavigationOptions = (clientId: string): INavigationItemProps[] => [
  {
    text: 'Contacts',
    to: `/spa/admin/clients/${clientId}`,
  },
  {
    text: 'Client Overview',
    to: `/spa/admin/clients/${clientId}/clientOverview`,
  },
  {
    text: 'Lenders',
    to: `/spa/admin/clients/${clientId}/associatedLenders`,
  },
];
